import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card, Calendar, Badge  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined } from '@ant-design/icons';
import Modalteachingschedule from './Modalteachingschedule';
import Modalcolor from './Modalcolor';
import Swal from 'sweetalert2/dist/sweetalert2.js'

import moment from 'moment'
import Getteachet2 from './Getteachet2';
import Getprograme from './Getprograme';
import Loadding from './Loadding';
import Modalroom from './Modalroom';
moment.updateLocale('en', {
  weekdaysMin : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
});



export default class Teach extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'1/2568',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          dd3:'',
          teacher:'',
          prenm:'',
        //  term:'',

          poname:'',
          Loadding:false,
         
        };
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getteachingschedule = this.getteachingschedule.bind(this);
        this.time = this.time.bind(this);
        this.getListData = this.getListData.bind(this);
        this.dateCellRender = this.dateCellRender.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
        

      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
 
           setTimeout(() => {
             this.getthschedule()
           }, 500);
      }

      
      componentDidMount() {

       this.getthschedule();
      }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
          //  Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthschedulesearch/'+this.state.term)
             Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthschedule/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }


      getteachingschedule() {
        this.setState({ Loadding:true });
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/showteachingschedule/'+this.state.term+'/'+this.state.idemp)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })


           
             this.setState({ showteachingschedule: res.data})
             if (res.data.length !== 0) {
               const teacher = res.data[0].poname;
             //  const prenm = res.data[0].prenm;
               this.setState({ teacher });
               this.setState({ Loadding:false });
             //  this.setState({ prenm });
             }else{
              Swal.fire({
                title: 'ไม่พบตารางสอน',
                icon: 'warning',
                text: 'ตรวจสอบการเพิ่มตารางสอน' ,
              // showCancelButton: true,
                confirmButtonText: 'ตกลง',
              // cancelButtonText: 'No, keep it'
              }).then((result) => {
                this.setState({ Loadding:false });
              })
             }
             
           }) 
         }, 0);
      }


      sentpdf() {
        setTimeout(() => {
           //ภายใน
          //   Axios.get('http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp)
          //  .then(res => {
          //    console.log(res);
          //  //  this.setState({ bankname: res.data, loading: false })
          //   // this.setState({ showteachingschedule: res.data})

          //    if (res.data.length !== 0) {
          //      const teacher = res.data[0].poname;
          //      this.setState({ teacher });
          //    } 
          //  }) 
          const encodedString = btoa(this.state.idemp);
          window.open('https://e-student.kpru.ac.th/tess/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+encodedString+'', '_blank');
        //  window.open('http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }



      onChange(value) {

          console.log(`selected ${value}`);
          const idemp = value;
          this.setState({ idemp });
        
          const teachersearcha = this.state.thschedule.filter( ({ teacher_id1	 }) => teacher_id1 === idemp );
                this.setState({ poname : teachersearcha[0].poname});
                this.setState({ prenm : teachersearcha[0].prenm});
          
        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/1/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck: res.data})
        //     }) 
        //   }, 0);

        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/2/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck2: res.data})
        //     }) 
        //   }, 0);

          setTimeout(() => {
            this.getteachingschedule()
          }, 500);
     }


         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          
           getListData(value) {
             let listData;
             this.state.showteachingschedule.map((showteachingschedule) => {

               if (value.weekdaysMin() === "Sun") {
                listData = [
                       { type: 'warning', content: 'This is warning event.' },
                       { type: 'success', content: 'This is usual event.' },
                     ];
               }
            //  <>{showteachingschedule.ss}  </>  
            return listData || [];
             });
             return listData || [];
           }


           dateCellRender(value) {
            const listData = this.getListData(value);
            return (
              <ul className="events">
                {listData.map(item => (
                  <li key={item.content}>
                    <Badge status={item.type} text={item.content} />
                  </li>
                ))}
              </ul>
            );
           }
          
           getMonthData(value) {
            if (value.month() === 8) {
              return 1394;
            }
           }
          
           monthCellRender(value) {
            const num = this.getMonthData(value);
            return num ? (
              <div className="notes-month">
                <section>{num}</section>
                <span>Backlog number</span>
              </div>
            ) : null;
           }
          


    render() {

        const { Option } = Select;
        const online = window.navigator.onLine;
      //  const teacher =  this.state.teachingschedule[0].map(teachingschedules => { {teachingschedule.poname} }  )     
      if (navigator.onLine) {
        console.log('online');
      } else {
        console.log('offline');
      }

     //รวมจำนวนชัวโมงสอนทั้งหมดของภาคการเรียน
      let sum = this.state.showteachingschedule.reduce(function(prev, current) {
        return prev + +current.hour1
      }, 0);
      console.log(sum)



        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางสอน</h4>
                </MDBAlert>
     <br/> */}
      <Card type="inner" className="text-center" title={<h5 className="unique-text"><MDBIcon far icon="list-alt" /> ตารางสอนอาจารย์</h5>} >

      


    <MDBRow>

            <MDBCol sm="5">
              
                    {/* <br/> */}

            </MDBCol>

            <MDBCol sm="2">
            <div>
            <div className="text-left"><label ><strong>ปีการศึกษา</strong></label></div> 
                    {/* <CaretDownOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />    */}
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกเทอม"
                            optionFilterProp="children"
                            onChange={this.updateSearchDepartment}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            value={this.state.term}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            className="text-left"
                        >
                            {/* <Option value="3/2563">3/2563</Option>
                            <Option value="1/2564">1/2564</Option>
                            <Option value="2/2564">2/2564</Option>
                            <Option value="3/2564">3/2564</Option> */}
                          
                           
                            
                               <Option value="1/2568">1/2568</Option>
                               <Option ative value="3/2567">3/2567</Option>
                               <Option value="2/2567">2/2567</Option>
                               <Option value="1/2567">1/2567</Option>
                               <Option ative value="3/2566">3/2566</Option>
                               <Option value="2/2566">2/2566</Option>
                               <Option value="1/2566">1/2566</Option>
                               <Option value="3/2565">3/2565</Option>
                                <Option value="2/2565">2/2565</Option>
                                  <Option value="1/2565">1/2565</Option>

                        </Select>
                    </div>

            { this.state.term === "" ?<> </>:<> 
                    <> 
                    {/* <UserOutlined style={{ fontSize: '30px', color: '#0d47a1' }}  />    */}
                    <div className="text-left"><label className="text-left mt-2"><strong>อาจารย์</strong></label></div> 
                        <Select
                            showSearch
                            style={{ width: 300 }}
                            placeholder="เลือกอาจารย์"
                            optionFilterProp="children"
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            className="text-left"
                        >
                            {/* <Option value="jack">Jack</Option>
                            <Option value="lucy">Lucy</Option>
                            <Option value="tom">Tom</Option> */}
                        {this.state.thschedule.map((emp,index )  => 
                        // <option value={emp.user_teacher}>{'อาจารย์ '+emp.poname}</option>
                        <option value={emp.teacher_id1}>{'อาจารย์ '+emp.poname}</option>
                        )}
                        </Select>
                        <br/>
                    </>
                    </> }

            </MDBCol>
  </MDBRow>

                {/* { this.state.empcouncilcheck.length === 0 ? <> </> : 
                <>
                <MDBAlert color="danger">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันอังคาร ของทุกเดือน
                </MDBAlert>
                </>}

                { this.state.empcouncilcheck2.length === 0 ? <> </> : 
                <>
                 <MDBAlert color="warning ">
                    <a href="#!" className="alert-link"> ! อาจารย์มีรายชื่อในการประชุมกรรมการบริหารมหาวิทยาลัย</a> ทุกวันพฤหัสบดี ของทุกเดือน
                 </MDBAlert>
                </>} */}

          { this.state.term === '' ? <></> :<> 
          <br/>
          <hr/>
          {/* <MDBAlert color="dark">
           <h5 className="text-center">ภาคเรียนที่ {this.state.term}</h5> 
          </MDBAlert> */}
          <h5 className="text-center">ตารางสอน ปีการศึกษา {this.state.term}</h5> 

               {this.state.poname === ''?<></>:<>  <h5 className="text-center teal-text"><MDBIcon icon="user-tie" /> {this.state.prenm}{this.state.poname} </h5> 
               <MDBBtn  color="primary" size="sm" onClick={this.sentpdf}><MDBIcon far icon="file-pdf" /> พิมพ์ตารางสอน</MDBBtn></> }

          {this.state.Loadding === true ? <>
            <div className="spinner-grow text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            </>: <>
            
            <MDBTable bordered small responsive>
                <MDBTableHead color="grey lighten-1">
                <tr>
                    <th  className="text-center">ลำดับ</th>
                    <th  className="text-center">รหัสวิชา</th>
                    <th  className="text-center">ชื่อวิชา</th>
                    <th  className="text-center">หน่วยกิต</th>
                    <th  className="text-center">หมู่เรียน</th>
                    <th  className="text-center">โปรแกรม</th>
                    <th  className="text-center">จำนวน</th>
                    <th  className="text-center">กลุ่ม</th>
                    <th  className="text-center">ผู้สอน</th>
                   
                    {/* <th  className="text-center">ผู้สอน</th> */}
                    <th  className="text-center">วัน</th>
                    <th  className="text-center">เวลา</th>
                    <th  className="text-center">ห้องเรียน</th>
                </tr>

                </MDBTableHead>
                {this.state.Loadding === true ? <>
                  <div className="spinner-grow text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </> : <>
                              <MDBTableBody>
                              {this.state.showteachingschedule.map((showteachingschedule,index) => {
                              
                                //กศบป
                                  const  time2 = Number (showteachingschedule.hour1*55)
                                  const  ddf = time2-5
                                  const  now = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                                  const totalsss = now.setMinutes(now.getMinutes()+ddf);
                                  const wanwela = new Date(totalsss)
                                  const wanwela1 =  wanwela.toLocaleTimeString()

                                  //ปกติ
                                  const  timenormal = Number (showteachingschedule.hour1*60)
                                  const  now2 = new Date("December 25, 1995 "+showteachingschedule.times1+" ");
                                  const totalsss2 = now2.setMinutes(now2.getMinutes()+timenormal);
                                  const wanwela2 = new Date(totalsss2)
                                  const normal =  wanwela2.toLocaleTimeString()
                                    
                                  return   <tr>
                                        <td>{index+1}</td>
                                        <td>{showteachingschedule.SUBJCODE}</td>
                                        <td className="text-left">{showteachingschedule.SUBJNAME}</td>
                                        <td>{showteachingschedule.CRHR}</td>
                                        <td>{showteachingschedule.id_major}</td>
                                        <td className="text-left">
                                          {showteachingschedule.t_mjname}
                                          {/* <Getprograme id_major = {showteachingschedule.id_major}/> */}
                                          </td>
                                        <td>{showteachingschedule.numregister}</td>
                                        <td>{showteachingschedule.group_id}</td>
                                        <td className="text-left">{showteachingschedule.prenm}{showteachingschedule.poname}
                                        {showteachingschedule.teacher_id2 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id2}  /></>:<></>}
                                        {showteachingschedule.teacher_id3 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id3}  /></>:<></>}
                                        {showteachingschedule.teacher_id4 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id4}  /></>:<></>}
                                        {showteachingschedule.teacher_id5 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id5}  /></>:<></>}
                                        {showteachingschedule.teacher_id6 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id6}  /></>:<></>}
                                        {showteachingschedule.teacher_id7 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id7}  /></>:<></>}
                                        {showteachingschedule.teacher_id8 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id8}  /></>:<></>}
                                        {showteachingschedule.teacher_id9 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id9}  /></>:<></>}
                                        {showteachingschedule.teacher_id10 != null ?<><Getteachet2 teacher_id2={showteachingschedule.teacher_id10}  /></>:<></>}
                                        </td>
                                        
                                        {/* <td> <p><Modalcolor idcolor={teachingschedule.group_id} /></p></td> */}
                                        {/* <td>อาจารย์{teachingschedule.poname}</td> */}

                                  {/* ช่วงที่1 */}
                                        <td> {showteachingschedule.ss === '1' ?<> จันทร์</>:<></> }
                                            {showteachingschedule.ss === '2' ?<> อังคาร</>:<></> }
                                            {showteachingschedule.ss === '3' ?<> พุธ</>:<></> }
                                            {showteachingschedule.ss === '4' ?<> พฤหัสบดี</>:<></> }
                                            {showteachingschedule.ss === '5' ?<> ศุกร์</>:<></> }
                                            {showteachingschedule.ss === '6' ?<> เสาร์</>:<></> }
                                            {showteachingschedule.ss === '7' ?<> อาทิตย์</>:<></> }
                                            {showteachingschedule.ss === '8' ?<> ---</>:<></> }
                                        </td>
                                        <td>
                                        {showteachingschedule.times1 === null || showteachingschedule.times1 === ''  ? <></> :<>
                                        {showteachingschedule.ss === '8' ?<> ---</>:<> {showteachingschedule.day === 'weekly2' ?<>{showteachingschedule.times2} - {showteachingschedule.timesend2}</>:<>{showteachingschedule.times1} - {showteachingschedule.timesend1}</>}</> }
                                          
                                          
                                              </> }
                                        </td>
                              <td >
                              {showteachingschedule.ss === '8' ?<> ---</>:<>
                                        {showteachingschedule.day === 'weekly1' ?<>
                                              {showteachingschedule.classroom1.substring(0, 2) ==='99'?<>
                                              <Modalroom idroom={showteachingschedule.classroom1} />
                                              </>:<> {showteachingschedule.classroom1} </>}
                                                          </>:<>
                                                          {showteachingschedule.day === 'weekly2' ?<>
                                                            {showteachingschedule.classroom2.substring(0, 2) ==='99'?<>
                                                            <Modalroom idroom={showteachingschedule.classroom2} />
                                                            </>:<> {showteachingschedule.classroom2} </>}
                                                                                                </>:<>
                                                                                                {showteachingschedule.day === 'weekly3' ?<>
                                                                                                          {showteachingschedule.classroom3.substring(0, 2) ==='99'?<>
                                                                                                          <Modalroom idroom={showteachingschedule.classroom3} />
                                                                                                        </>:<> {showteachingschedule.classroom3} </>}
                                                                                                </>:<>
                                                                                                    {showteachingschedule.day === 'weekly4' ?<>
                                                                                                        {showteachingschedule.classroom4.substring(0, 2) ==='99'?<>
                                                                                                          <Modalroom idroom={showteachingschedule.classroom4} />
                                                                                                          </>:<> {showteachingschedule.classroom4} </>}
                                                                                                    </>:<>ไม่พบข้อมูล</>}
                                                                                                
                                                                                                </>}
                                                                                                
                                                                                                  </>}
                                        </>}
                              </> }
                              
                              
                              </td>

                              
                                        </tr>
                                
                              })}   
                              </MDBTableBody>
                </> }

            </MDBTable>
              {sum === 0?<></>:<><p className="indigo-text text-left" >ชั่วโมงสอนรวม {sum} ชั่วโมง</p></>}
            </> }
            {/* <p>หมายเหตุ : ข้อมูลใช้ประกอบการจัดตารางสอน ไม่ให้ชนกับการประชุม</p> */}
        </>}

        </Card>

        {/* <Calendar dateCellRender={this.dateCellRender} monthCellRender={this.monthCellRender} />, */}
            </MDBContainer>

        )
    }
}
